// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Sort by`
};

const el_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Ταξινόμηση κατά`
};

const ru_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Сортировка`
};

const he_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `מיין לפי`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sort_by = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sort_by(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sort_by", locale)
	if (locale === "en") return en_sort_by(inputs)
	if (locale === "el") return el_sort_by(inputs)
	if (locale === "ru") return ru_sort_by(inputs)
	if (locale === "he") return he_sort_by(inputs)
	return "sort_by"
};